import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PageNameService {
  public activeScreenName = signal<string | null>(null);

  public setScreenName(screenName: string | null): void {
    this.activeScreenName.set(screenName);
  }

  public get screenName() {
    return this.activeScreenName;
  }
}
